import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SupplierReidPage } from '@features/admin/supplier-reid';

const searchSchema = z.object({
  state: z.enum(['ALL', 'READY', 'ALREADY_DONE', 'CONFLICT', 'NOT_FOUND', 'DUPLICATE', 'INVALID']).optional().default('ALL'),
});

export type AdminSupplierReidSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/admin/supplier-reid/')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <SupplierReidPage />;
}
